export default {"src":"/_next/static/media/help.2a08ee5e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};